export { PlanOvertime } from './plan_overtime/page';
export { PlanOvertimeBawahan } from './plan_overtime_bawahan/page';

export { AppPresensi } from './presensiApp/presensi';
export { Attendance } from './attendance/page';
export { Leave } from './leave/page';
export { Permit } from './permit/page';
export { Overtime } from './overtime/page';

// Page crud
export { AddPermit } from './add_permit/page';
export { AddOvertime } from './add_overtime/page';



// WEBPACK FOOTER //
// ./src/pages/presensi/index.ts